export default "__VITE_PUBLIC_ASSET__2aaf59dd__"